<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.75" y="1.75" width="14.5" height="12.5" fill="#FFD25E" stroke="black" stroke-width="1.5"/>
</svg>
